const recruitmentInputs = [
   { name: "firstName", placeholder: "imię" },
   { name: "lastName", placeholder: "nazwisko" },
   { name: "email", placeholder: "e-mail" },
   { name: "repeatEmail", placeholder: "powtórz e-mail" },
   {name: "phone", placeholder:"numer telefonu"},
];
export default recruitmentInputs;
